export default "assets/images/icons/search-b1279186.svg";